module.exports = __webpack_public_path__ + "assets/img/logo.0a86b794.png";